(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[569],{

/***/ 7609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurant",
      function () {
        return __webpack_require__(9527);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Restaurant; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3495);
/* harmony import */ var _styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _components_Reusable_Gallery_Gallery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7757);
/* harmony import */ var _components_Reusable_Banner_Topbanner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5871);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6066);
/* harmony import */ var _components_Reusable_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2468);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9521);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9664);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _components_Reusable_Form_DiningPageForm__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9056);
/* harmony import */ var _components_Schema__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8237);
/* harmony import */ var _components_Reusable_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28);















function Restaurant() {
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const testimonial = [
        {
            name: "Shaifali Goyal",
            title: "From India",
            description: "The canteen inside offers a wide range of options to eat and drink with lovely seats. There are different shops like bakery, apple chips, furniture, food and beauty items, etc."
        },
        {
            name: "Saket Suman",
            title: "From India",
            description: "well placed on the edge that it gives you extra thrill. Apart from rides, it has decent facilities like cafeteria, bakery, restaurant as well."
        },
        {
            name: "Nick Sha",
            title: "From India",
            description: "Activities are good, i. Suggest go with children they enjoy a lot then adults,And don't forget to eat from their is one bakery shop awsm and fresh food I love it."
        }
    ];
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    const diningFaqs = [
        {
            title: "Can I make dining reservations in advance?",
            content: "Yes, at Adventure Resorts Kufri, we offer the option to make dining reservations in advance. Whether you're looking to dine at our exquisite on-site restaurant or enjoy a special meal at one of our wonderful dining venues, we recommend making reservations ahead of time to guarantee your desired dining time and ensure a seamless experience.            "
        },
        {
            title: "Do you offer any meal packages or all-inclusive dining options?",
            content: "Yes, we offer various meal packages and all-inclusive dining options to ensure that you have a hassle-free dining experience during your stay with us. Whether you're looking for a comprehensive all-inclusive package that covers breakfast, lunch, dinner, and snacks, or a specific meal package that includes select meals, we have options to suit your needs. For more information about our meal packages and all-inclusive dining options, we recommend contacting our reservations team or visiting our website for the latest offerings and details.            "
        },
        {
            title: "Can I request a special celebration or romantic dinner setup?",
            content: "Certainly! At Adventure Resort Kufri, we are pleased to offer special celebration and romantic dinner setups upon request. Whether it's a birthday, anniversary, or a romantic evening, our team will go the extra mile to create a memorable and enchanting dining experience for you and your loved ones. Please contact our booking team to discuss your specific requirements.            "
        },
        {
            title: "Are there any kid-friendly dining options or childrens menus?",
            content: "Yes, we offer kid-friendly dining options and a dedicated menu to cater to our young guests. Our menus feature a variety of delicious and nutritious options designed to satisfy even the pickiest eaters. We strive to make dining a delightful experience for the whole family at Adventure Resort Kufri.            "
        },
        {
            title: "What happens if I do not reconfirm my dining booking?",
            content: "We highly recommend reconfirming your dining booking to ensure a seamless experience. If you fail to reconfirm your reservation, there is a possibility that your booking may be released to accommodate other guests. To avoid any inconvenience, we encourage guests to contact our reservations team or the restaurant directly to reconfirm their dining bookings.             "
        }
    ];
    const handleScrollDown = (e)=>{
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_12__.gsap.registerPlugin(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_13__.ScrollToPlugin);
        e.stopPropagation();
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_12__.gsap.to(window, {
            speed: 100,
            duration: 1,
            scrollTo: {
                y: "#book-a-table",
                offsetY: 70
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Best Restaurant in Kufri - Adventure Resorts, Shimla"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Adventure Resorts, Kufri, Shimla offers multiple restaurants like Wok on the Peak, spacious dining areas, & huge sitting capacity for celebrations. "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Multi Cuisine Restaurants, Food & Dining, Traditional Food, Best Restaurant In Kufri"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.adventureresortkufri.com/restaurant"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Schema__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                name: "RestaurantFaq"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reusable_Banner_Topbanner__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "Food & Dining at Adventure Resorts Kufri",
                bgImage: "/images/packages-banner.png",
                target: "#firstsec"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().story_sec), " common_padding"),
                id: "firstsec",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row justify-content-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-md-8 common_title",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Gastronomical delights"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "We have developed a unique and distinctive menu that features ultimate dishes for our visitors in order to offer you with an experience that will live long in your memory. You will be able to savor the finest examples of local as well as international unusual flavors. Our menu, which features dishes from a variety of cuisines, is always an enjoyable selection from which to pick."
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_sec), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child), " row align-items-center mb-4"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child_left), " col-md-6"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "/images/speciality-img.png",
                                        layout: "fill",
                                        objectFit: "cover",
                                        alt: "Speciality Image"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child_right), " col-md-6 common_title"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "Our Best Speciality"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "We've introduced a unique dining experience in Kufri that will satisfy your taste buds with our exclusive delicacies since we believe in providing genuine, pure experience. The home-style meal, which is always made with a local twist, will keep you healthy and refreshed."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reusable_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_11__/* .SecoundaryButton */ .me, {
                                            onClick: handleScrollDown,
                                            buttonText: "Book A Table"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child), " row align-items-center"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child_right), " ").concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child_right_two), " col-md-6 common_title"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "Discover Your Drink Destiny"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Relax and replenish with drinks from the Bar, which has a wide range of mocktails and cocktails made with premium ingredients which makes it the best bar in Kufri. Drink one of our cold beverages, which include fresh juices and other options, to satisfy your thirst. Indulge in some quality time with your loved ones here."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reusable_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_11__/* .SecoundaryButton */ .me, {
                                            onClick: handleScrollDown,
                                            buttonText: "Book A Table"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child_left), " ").concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().speciality_child_left_two), " col-md-6"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "/images/bar.png",
                                        layout: "fill",
                                        objectFit: "cover",
                                        alt: "Speciality Image"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().plan_sec), " row"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().plan_sec_left), " col-md-4 common_title mobile_text_center"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-md-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                ...settings,
                                className: "testi_slider",
                                children: testimonial.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "/icons/quote.svg",
                                                width: 33,
                                                height: 33,
                                                alt: "Quote Icon"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: item.description
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: item.title
                                            })
                                        ]
                                    }, index))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_styles_Pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_14___default().plan_sec_right), " col-md-8"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: "/images/restaurant.png",
                            layout: "fill",
                            objectFit: "cover",
                            alt: "Restaurant Image"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "common_padding",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container common_title text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: "Food Gallery"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reusable_Gallery_Gallery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "",
                id: "book-a-table",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container common_title text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: "Book Your Table"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reusable_Form_DiningPageForm__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "common_padding",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-center common_title",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: "FAQs"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "accordion_parent col-md-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reusable_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    items: diningFaqs
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,594,960,8,774,888,179], function() { return __webpack_exec__(7609); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);